/* eslint-disable @typescript-eslint/no-unused-vars */
import { IActionButton, ITableAction ,ITableFilter} from "../../../../interfaces";
import { TableContent } from "./TableContent";
import { TablePaginator } from "./TablePaginator";
import { TableTooltip } from "./TableTooltip";
import { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import { APP_CONSTANTS } from "../../../../constants";
import { PATIENT_FILTER ,tableType as tableTypeE  } from "../../../../enums";
import { StyledPatientsListTableWrapper, StyledTableWrapper } from "../../../../styles";
import { RootState } from "../../../../store";
import { idType } from "../../../../types";


interface ISharedTableProps {
  tableName: string;
  onRowClick: (...args: any) => void;
  forceRefetch?: boolean; // used to force refetch data, in case of an event trigged like creation
  withTooltip?: boolean;
  tableType: tableTypeE;
  isPaginated: boolean; // determine either the pagination is allowed in the component or no
  tableHeaders: Array<{ key: string; label: string }>;
  tableFilters?: Array<ITableFilter>;
  tooltipActionButtons?: Array<IActionButton>;
  searchHandler?: () => void;
  isTableSearcheable?: boolean;
  totalPatientTreated?: number;
  fetchHook: any;
  hookParams?: Array<string>; //define the parameters, that will be used in query params the hook

  fetchSingleEntityHook: any;
  rowActions: Array<ITableAction>; // an array of actions, like update row, block user ...
  onClickParamKey?: string;

}

/**
 *
 * @param props
 * @returns
 */
export const SharedTable = (props: ISharedTableProps) => {

  /* local states */
  const [totalPages, setTotalPages] = useState<number | null>(null);

  const [currentPage, setCurrentPage] = useState<number>(1);

  const [searchTerm, setSearchTerm] = useState<string>("");



  const [dateRange, setDateRange] = useState<[any, any]>([null, null]);


  const [centerId, setCenterId] = useState<idType | null>(null);




  const { forceRefetch } = useSelector((state: RootState) => state.table);

  // Create an object with keys from the array and initialize values to undefined
  // const obj = props.hookParams?.reduce((acc, key) => {
  //     acc[key] = undefined; // You can initialize with any value or leave it out
  //     return acc;
  // }, {} as Record<string, any>);
  /* fetching data */
  const { data, isLoading, isFetching, refetch, isError } = props.fetchHook({
    page: currentPage,
    filters: { dateRange, centerId, location },
    // filters: {
    //   ...searchCriterias,
    // },

    search: searchTerm,
  });

  useEffect(() => {
    if (data) {
      const computedTotal = Math.ceil(
        data?.totalResults / APP_CONSTANTS.TABLES[props.tableType].limit
      );
      setTotalPages(computedTotal > 0 ? computedTotal : 1);
    }
  }, [data]);
  useEffect(() => {
    refetch();
  }, [forceRefetch]);

  /* props */
  const {
    rowActions,
    withTooltip = true,
    tableFilters,
    tableType,
    tooltipActionButtons,
    tableName,
    isPaginated,
    onClickParamKey,

  } = props;

  const searchHandler = (s: string, { dateRange, location, centerId }: any) => {
    //  setSearchCriterias

    let l = PATIENT_FILTER.ALL_PATIENTS;
    // the search will be performed for the whole patients table
    // instead of the display, that will be limited for just the selected location

    if (s.length == 0) l = location;

    setSearchTerm(s);
    setDateRange(dateRange);
    setCenterId(centerId);
  };

  return (
    <>
      <StyledPatientsListTableWrapper>
        <>
          {withTooltip && (
            <TableTooltip
              title={tableName}
              searchHandler={searchHandler}
              isLoading={isLoading || isFetching}
              actionButtons={tooltipActionButtons}
              filters={tableFilters}
            />
          )}
          <StyledTableWrapper>
            <TableContent
              onClickParamKey={onClickParamKey}
              rowActions={rowActions}
              headers={props.tableHeaders}
              isError={isError}
              onRowClick={props.onRowClick}
              isLoading={isLoading || isFetching}
              data={data?.results}
            />
          </StyledTableWrapper>

          {/* end table content */}
          {isPaginated && totalPages && (
            <TablePaginator
              setCurrentPage={setCurrentPage}
              tableType={tableType}
              totalPages={totalPages}
              currentPage={currentPage}
            />
          )}
        </>
      </StyledPatientsListTableWrapper>
    </>

  );
};
